import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DashboardHeaderProps {
  onNewUpload: () => void;
}

export const DashboardHeader = ({ onNewUpload }: DashboardHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      {/* Заголовок с кнопкой на одной линии */}
      <div className="flex justify-between items-start mb-2">
        <h1 className="text-2xl font-bold">{t('common.my_records')}</h1>

        {/* Мобильная кнопка - только иконка */}
        <Button
          size="sm"
          className="sm:hidden flex-shrink-0"
          onClick={onNewUpload}
        >
          <Upload size={16} />
        </Button>

        {/* Десктопная кнопка - с текстом */}
        <Button
          className="hidden sm:flex"
          onClick={onNewUpload}
        >
          <Upload size={16} className="mr-2" />
          <span>{t('dashboard.upload_new_file')}</span>
        </Button>
      </div>

    </div>
  );
};